import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {InventorySearchModel} from "../inventory-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {InventorySearchPageComponent} from "../inventory-search-page/inventory-search-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-inventory-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(InventorySingleSelectEditControlComponent),
        provideSearchModel(InventorySearchModel)
    ]
})
export class InventorySingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<InventorySearchModel> {
    constructor(model: InventorySearchModel, injector: Injector) {
        super(model, injector, "inventoryId", "name");
        this.labelSearchField = "identifier";
        this.extendedSearchComponent = InventorySearchPageComponent;
    }
}
